/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A peak that drifts rightward down the rows shows an increasing trend.`)
};

const es_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un pico que se desplaza hacia la derecha a lo largo de las filas muestra una tendencia creciente.`)
};

const de_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Gipfel, der über die Reihen hinweg nach rechts wandert, zeigt einen steigenden Trend.`)
};

const nl_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een piek die naar rechts verschuift bij de rijen naar beneden toont een stijgende trend.`)
};

const fr_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un pic qui dérive vers la droite au fil des lignes montre une tendance croissante.`)
};

const it_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un picco che si sposta verso destra scendendo lungo le righe mostra una tendenza crescente.`)
};

const pt_br2_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um pico que se desloca para a direita ao longo das linhas mostra uma tendência crescente.`)
};

const pt_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um pico que se desloca para a direita ao longo das linhas mostra uma tendência crescente.`)
};

const ja_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を下るにつれてピークが右にずれていく場合、増加傾向を示しています。`)
};

const zh_ridge_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`峰值沿各行向右漂移，表示呈上升趋势。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_ex2", locale)
	if (locale === "en") return en_ridge_ex2(inputs)
	if (locale === "es") return es_ridge_ex2(inputs)
	if (locale === "de") return de_ridge_ex2(inputs)
	if (locale === "nl") return nl_ridge_ex2(inputs)
	if (locale === "fr") return fr_ridge_ex2(inputs)
	if (locale === "it") return it_ridge_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_ex2(inputs)
	if (locale === "pt") return pt_ridge_ex2(inputs)
	if (locale === "ja") return ja_ridge_ex2(inputs)
	return zh_ridge_ex2(inputs)
};